import React from 'react';
import { Checkbox, ICheckboxProps } from '../../../../../../ui';
import { useDetailsFormContext } from '../hooks/useDetailsFormContext';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';

export const SaveDetails = (props: Partial<ICheckboxProps>) => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
	} = useDetailsFormContext();

	return (
		<Checkbox
			label={t('parking_personal_details_remember_details_label')}
			invalid={!!errors.saveDetails}
			{...props}
			{...register('saveDetails')}
		/>
	);
};
